/** Accueil : salutation, lanceur d'applications, fichiers récents. */
import { el } from '../ui/dom.js';
import { icon, TYPE_META } from '../ui/icons.js';
import { Drive } from '../api.js';
import { fileTile } from './drive.js';

const APP_TILES = [
  { nav: '/messages', label: 'Messages', sub: 'Discuter en direct', color: '#ef795b', icon: 'chat' },
  { type: 'doc', label: 'Document', sub: 'Traitement de texte', color: '#4a86ff', icon: 'doc' },
  { type: 'sheet', label: 'Feuille', sub: 'Tableur', color: '#23b26d', icon: 'sheet' },
  { type: 'slides', label: 'Présentation', sub: 'Diaporama', color: '#f5a623', icon: 'slides' },
  { nav: '/calendar', label: 'Agenda', sub: 'Calendrier', color: '#e0567a', icon: 'calendar' },
  { nav: '/tasks', label: 'Tâches', sub: 'À faire', color: '#a855f7', icon: 'tasks' },
  { nav: '/meet', label: 'Meet', sub: 'Visio (bientôt)', color: '#06b6d4', icon: 'meet' },
];

export function renderHome(ctx) {
  const { content, user, navigate, shell } = ctx;
  ctx.setCrumbs([{ label: 'Accueil' }]);

  const hour = new Date().getHours();
  const greet = hour < 6 ? 'Bonne nuit' : hour < 12 ? 'Bonjour' : hour < 18 ? 'Bon après-midi' : 'Bonsoir';

  const grid = el('div', { class: 'app-grid' });
  for (const a of APP_TILES) {
    const tile = el('button', { class: 'app-tile', style: { border: 'none', font: 'inherit', color: 'inherit', cursor: 'pointer' } },
      el('div', { class: 'glyph', style: { background: a.color }, html: icon(a.icon, 24) }),
      el('b', {}, a.label),
      el('small', {}, a.sub)
    );
    tile.addEventListener('click', () => { if (a.nav) navigate(a.nav); else shell.create(a.type, null); });
    grid.appendChild(tile);
  }

  const recentWrap = el('div', { style: { marginTop: '34px' } },
    el('h2', { style: { fontSize: '18px', marginBottom: '14px' } }, 'Récents'),
    el('div', { class: 'grid', id: 'recent-grid' }, el('div', { style: { color: 'var(--text-faint)' } }, 'Chargement…'))
  );

  content.append(
    el('div', { class: 'hero' },
      el('h1', {}, `${greet}, ${user.given_name || user.nickname || ''} 👋`),
      el('p', {}, 'Reprenez votre travail ou créez quelque chose de nouveau.')
    ),
    grid,
    recentWrap
  );

  Drive.list({ view: 'recent' }).then(({ nodes }) => {
    const g = content.querySelector('#recent-grid');
    g.innerHTML = '';
    if (!nodes.length) {
      g.appendChild(el('div', { class: 'empty', style: { gridColumn: '1/-1' } },
        el('div', { class: 'ico', html: icon('recent', 30) }),
        el('h3', {}, 'Rien de récent'),
        el('div', {}, 'Vos derniers fichiers ouverts apparaîtront ici.')));
      return;
    }
    nodes.slice(0, 12).forEach((n) => g.appendChild(fileTile(n, { navigate })));
  }).catch(() => {});
}
